import { render, staticRenderFns } from "./notes_activity_header.vue?vue&type=template&id=0d1e9bca"
import script from "./notes_activity_header.vue?vue&type=script&lang=js"
export * from "./notes_activity_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports